<template>
  <div class="text-[13px]">
    <PageHeader :title="tabLabel" :breadcrumbs="breadcrumbs">
      <template #bottom>
        <Page_Tabs class="px-6" :tabs="pageTabs" no-border />
      </template>
    </PageHeader>
    <div class="px-8 py-6">
      <component :is="view" :key="viewKey" @pending="pending = $event" />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';
import { API, TABS } from './hermes';
import HermesOverview from './HermesOverview.vue';
import HermesRuns from './HermesRuns.vue';
import HermesRunDetail from './HermesRunDetail.vue';
import HermesTemplates from './HermesTemplates.vue';
import HermesTemplateEditor from './HermesTemplateEditor.vue';
import HermesExecutors from './HermesExecutors.vue';
import HermesExecutorDetail from './HermesExecutorDetail.vue';
import HermesApprovals from './HermesApprovals.vue';
import HermesSchedules from './HermesSchedules.vue';
import HermesScheduleEditor from './HermesScheduleEditor.vue';
import HermesHats from './HermesHats.vue';
import HermesHatEditor from './HermesHatEditor.vue';
import HermesTests from './tests/HermesTests.vue';
import HermesConsole from './console/HermesConsole.vue';

const VIEWS = {
  AdminHermesOverview: 'HermesOverview',
  AdminHermesRuns: 'HermesRuns',
  AdminHermesRun: 'HermesRunDetail',
  AdminHermesTemplates: 'HermesTemplates',
  AdminHermesTemplate: 'HermesTemplateEditor',
  AdminHermesExecutors: 'HermesExecutors',
  AdminHermesExecutor: 'HermesExecutorDetail',
  AdminHermesApprovals: 'HermesApprovals',
  AdminHermesApproval: 'HermesApprovals',
  AdminHermesSchedules: 'HermesSchedules',
  AdminHermesSchedule: 'HermesScheduleEditor',
  AdminHermesHats: 'HermesHats',
  AdminHermesHat: 'HermesHatEditor',
  AdminHermesTests: 'HermesTests',
  AdminHermesConsole: 'HermesConsole',
};

export default {
  name: 'HermesAdmin',
  components: {
    PageHeader, Page_Tabs, HermesOverview, HermesRuns, HermesRunDetail, HermesTemplates, HermesTemplateEditor,
    HermesExecutors, HermesExecutorDetail, HermesApprovals, HermesSchedules, HermesScheduleEditor, HermesHats, HermesHatEditor, HermesTests, HermesConsole,
  },
  data() {
    return { pending: 0 };
  },
  computed: {
    tabs() {
      const superuser = !!this.$store.getters['auth/current_user']?.is_superuser;
      return TABS.filter((t) => !t.superuserOnly || superuser);
    },
    pageTabs() {
      return this.tabs.map((t) => ({
        id: t.key,
        label: t.label,
        description: t.description,
        to: this.$router.resolve({ name: t.route }).path,
        badge: t.key === 'approvals' && this.pending ? String(this.pending) : null,
      }));
    },
    tab() {
      return this.$route.meta.hermesTab || 'overview';
    },
    view() {
      return VIEWS[this.$route.name] || 'HermesOverview';
    },
    viewKey() {
      const params = { ...this.$route.params };
      ['section', 'tab', 'effectId'].forEach((k) => delete params[k]);
      return `${this.view}:${JSON.stringify(params)}`;
    },
    tabLabel() {
      return (TABS.find((t) => t.key === this.tab) || TABS[0]).label;
    },
    breadcrumbs() {
      return [{ label: 'Admin Console' }, { label: 'Hermes', to: { name: 'AdminHermesOverview' } }];
    },
  },
  mounted() {
    this.loadPending();
  },
  methods: {
    async loadPending() {
      try {
        const { data } = await this.$axios.get(`${API}/effects/summary/`);
        this.pending = data.pending || 0;
      } catch {
        this.pending = 0;
      }
    },
  },
};
</script>
